module.exports = __webpack_public_path__ + "img/ic_best_price.92b80c35.svg";